import React from 'react'
import styled from 'styled-components'
import { MyImage } from '~/components/ui/MyImage'
import { OrderInfo } from '~/graphqls/types'
import { FenToYuan } from '~/utils'
import { SkuTypeName } from '~/configs'

const StyledProductInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`

const StyledProductInfoBody = styled.div`
  margin-left: 12px;
`

const StyledProductInfoTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
  color: ${props => props.theme.dark2};
`

const StyledProductInfoPrice = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${props => props.theme.dark4};
  span {
    font-size: 16px;
    color: ${props => props.theme.errorColor};
  }
`

export const ProductInfo: React.FC<{
  data: OrderInfo
  showType?: boolean
}> = ({ data, showType = false }) => {
  return (
    <StyledProductInfo>
      <MyImage
        tag="v400"
        src={data?.artworkUrl}
        style={{ width: 72, height: 72, borderRadius: 16 }}
        lazy={false}
      />
      <StyledProductInfoBody>
        <StyledProductInfoTitle>{data?.name}</StyledProductInfoTitle>
        <StyledProductInfoPrice>
          {showType ? SkuTypeName[data.type] : ''}{' '}
          <span>¥{FenToYuan(data.price)}</span>
        </StyledProductInfoPrice>
      </StyledProductInfoBody>
    </StyledProductInfo>
  )
}
